import axios from "axios";
/**
 *
 * CatAPI
 *
 * https://thecatapi.com
 *
 */
export var CatApi;
(function (CatApi) {
    CatApi.api = {
        getBreeds: () => {
            return rest.get('/breeds').then(response => response.data);
        },
        getCategories: () => {
            return rest.get('/categories').then(response => response.data);
        },
        searchImages(filter) {
            return rest.get('/images/search', { params: filter }).then((response) => response.data);
        },
        searchFavourites(filter) {
            return rest.get('/favourites', { params: filter }).then(response => response.data);
        },
        saveAsFavourite(image_id) {
            return rest.post('/favourites', { image_id: image_id });
        }
    };
})(CatApi || (CatApi = {}));
const rest = axios.create({
    baseURL: 'https://api.thecatapi.com/v1',
    headers: { 'x-api-key': 'API_KEY' }
});
